import classNames from 'classnames';
import React from 'react';
import { FontIconBtn } from '@meitu/saas-ui';
import { CustomTitle } from '@meitu/saas-ui/es/title';
import { isIntl } from '@/react-process-env';
import { isPcPlatform } from '@/utils/auth';
import AIMeidouBtn from '../../components/ai-meidou-btn';
import './back-title.less';
import IconFont from '@meitu/xdesign-icon-font';

const BackTitle: React.FC<{
    handleClick: () => void;
    title: string;
    iconName: string;
    demoUrl?: string;
    showMeidouBtn?: boolean;
    showDemo?: boolean;
    onDemoClick?: () => void;
}> = React.memo(
    ({ handleClick, title, iconName, demoUrl, showMeidouBtn = false, showDemo = true, onDemoClick = () => {} }) => {
        const leftNode = (
            <div
                className="b-custom-title_left c-more__custom-title back"
                onClick={() => {
                    handleClick();
                }}
            >
                <IconFont fontSize={16} name="BackArrowBlack" />
                <span className="b-custom-title_text">{title}</span>

                {!isPcPlatform() && showDemo ? (
                    <div className={classNames(['demo', isIntl ? ' demo-intl' : ''])}>
                        <FontIconBtn
                            name={iconName}
                            type="button"
                            fontSize={14}
                            onClick={(e: any) => {
                                e.stopPropagation();
                                onDemoClick?.();
                            }}
                            color="var(--text-normal_3)"
                        />

                        {demoUrl ? (
                            <video src={demoUrl} width={230} height={158} autoPlay={true} loop={true}></video>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );

        return <CustomTitle leftNode={leftNode} rightNode={showMeidouBtn ? <AIMeidouBtn /> : null} />;
    },
);

export default BackTitle;
